function get_header_column_id(header_cell) {
  return header_cell?.dataset?.col || '';
}

export default {
  apply_hidden_columns() {
    if (!this.enable_column_toggle) {
      return;
    }

    (this.headers || []).forEach((header) => {
      if (!this.is_toggleable_column(header)) {
        return;
      }
      const column_id = this.get_column_id(header);
      this.set_column_visibility(column_id, !this.is_column_hidden(column_id));
    });
    this.refresh_horizontal_scroll();
  },

  hide_column(column_id) {
    if (!this.can_hide_column(column_id)) {
      return;
    }

    this.hidden_column_ids = [...this.hidden_column_ids, column_id];
    this.$nextTick(() => {
      this.set_column_visibility(column_id, false);
      this.refresh_horizontal_scroll();
    });
  },

  restore_column(column_id) {
    if (!column_id) {
      return;
    }

    this.hidden_column_ids = this.hidden_column_ids.filter((id) => id !== column_id);
    this.$nextTick(() => {
      this.set_column_visibility(column_id, true);
      this.refresh_horizontal_scroll();
    });
  },

  handle_header_click(event) {
    if (!this.enable_column_toggle) {
      return;
    }
    const column_id = this.get_clicked_header_column_id(event);
    if (!column_id) return;
    const matched_header = this.find_toggleable_header(column_id);
    if (!this.is_toggleable_column(matched_header)) return;
    this.hide_column(column_id);
  },
  get_clicked_header_column_id(event) {
    const header_cell = event.target.closest('th[data-col]');
    return header_cell ? get_header_column_id(header_cell) : '';
  },
  find_toggleable_header(column_id) {
    return (this.headers || []).find((header) => this.get_column_id(header) === column_id);
  },

  bind_header_toggle_events() {
    if (!this.enable_column_toggle) {
      return;
    }

    const table_element = this.get_table_element();
    if (!table_element || table_element.dataset.columnToggleBound === 'true') {
      return;
    }

    table_element.addEventListener('click', this.handle_header_click);
    table_element.dataset.columnToggleBound = 'true';
  },

  unbind_header_toggle_events() {
    const table_element = this.get_table_element();
    if (!table_element || table_element.dataset.columnToggleBound !== 'true') {
      return;
    }

    table_element.removeEventListener('click', this.handle_header_click);
    delete table_element.dataset.columnToggleBound;
  },
};
